import { useEffect, useState } from "react";
import CustomBarChart from "../Charts/CustomBarChart";
import CommonCard from "../ui/CommonCard/CommonCard";
import classes from "./LabDashboard.module.css";
import { useAuth } from "../../context/AuthContext";
import { env } from "../../constants/env";
import axios from "axios";

const colorPalette = ["#C607CA", "#1302FB", "#1CDF03", "#FE9900", "#E60101"];

const AssessorDashboard = () => {
  
  const [labs, setLabs] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user, token } = useAuth();
  const labId = user?.labId;

  useEffect(() => {
    const fetchLab = async () => {
      try {
         const res = await axios.get(`${env.kataApiUrl}/api/labs`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLabs(res.data);
        console.log("Fetched labs:", res.data);
      } catch (error) {
        console.error("Error fetching lab dashboard:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLab();
  }, [labId]);

  if (loading) return <p>Loading...</p>;
  if (!labs) return <p>Labs not found</p>;

  // Build bar chart data from staff distribution
const staffDistribution = labs.reduce(
  (acc, lab) => {
    acc.Degree += lab.degreeHolders || 0;
    acc.Diploma += lab.diplomaHolders || 0;
    acc.Certificate += lab.certificateHolders || 0;
    acc.Clerks += lab.dataClerks || 0;
    acc.Phlebotomists += lab.phlebotomists || 0;
    acc.Cleaners += lab.cleaners || 0;
    acc.Drivers += lab.drivers || 0;
    acc.Others += lab.others || 0;
    return acc;
  },
  { Degree: 0, Diploma: 0, Certificate: 0, Clerks: 0, Phlebotomists: 0, Cleaners: 0, Drivers: 0, Others: 0 }
);

const chartData = Object.entries(staffDistribution).map(([name, number]) => ({ name, number }));

console.log("Aggregated staff distribution:", chartData);

  return (
    <div className={classes.wrapper}>
      <h2>Dashboard</h2>

      {/* Bar Chart */}
      <CommonCard>
        <div className={classes.cardHeader}>
          <h5>Laboratories staff distribution</h5>
        </div>
        <CustomBarChart data={chartData} colors={colorPalette} />
      </CommonCard>
    </div>
  );
};

export default AssessorDashboard;
